import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BtnLoadingComponent } from './btn-loading/btn-loading.component';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ng2-tooltip-directive';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { OutlineBtnLoadingComponent } from './outline-btn-loading/outline-btn-loading.component';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { NoDataComponent } from './no-data.component';
import { FullLoaderComponent } from './full-loader.component';
import { Error404Component } from './error-404.component';
import { Error500Component } from './error-500.component';
import { NotFoundComponent } from './not-found.component';
import { RouterModule } from '@angular/router';
import { appIframeResizer } from 'app/core/directive/app-iframe-resizer.directive';
import { HoverClassDirective } from '@fuse/directives/hover-class.directive';
import { OnlyNumberDirective } from '@fuse/directives/only-number.directive';
import { TwoDigitDecimaNumberDirective } from '@fuse/directives/decimal-input.directive';
import { InputRegexDirective } from '@fuse/directives/input-regex.directive';
import { ellipsisTooltipDirective } from '@fuse/directives/ellipsis-tooltip.directive';
import { AutofocusDirective } from '@fuse/directives/autofocus.directive';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { WarmupSettingsComponent } from './warmup-settings/warmup-settings.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatSliderModule } from '@angular/material/slider';
import { UiSwitchModule } from 'ngx-ui-switch';

@NgModule({
    declarations: [
        BtnLoadingComponent,
        DeleteDialogComponent,
        OutlineBtnLoadingComponent,
        NoDataComponent,
        FullLoaderComponent,
        Error404Component,
        Error500Component,
        NotFoundComponent,
        appIframeResizer,
        HoverClassDirective,
        OnlyNumberDirective,
        TwoDigitDecimaNumberDirective,
        InputRegexDirective,
        ellipsisTooltipDirective,
        AutofocusDirective,
        WarmupSettingsComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        TranslateModule,
        TooltipModule.forRoot({
            hideDelay: 0
        }),
        MatIconModule,
        MatDialogModule,
        MatRippleModule,
        RouterModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        MatMenuModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        MatSliderModule,
        UiSwitchModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BtnLoadingComponent,
        TranslateModule,
        TooltipModule,
        DeleteDialogComponent,
        OutlineBtnLoadingComponent,
        MatIconModule,
        NoDataComponent,
        FullLoaderComponent,
        Error404Component,
        Error500Component,
        NotFoundComponent,
        appIframeResizer,
        HoverClassDirective,
        OnlyNumberDirective,
        TwoDigitDecimaNumberDirective,
        InputRegexDirective,
        ellipsisTooltipDirective,
        AutofocusDirective,
        WarmupSettingsComponent
    ]
})
export class SharedModule
{
}
